/**
 * Dashboard Walkthrough
 */

$(document).on('click', '.dw-close', (e) => {
  $('.dashboard-walkthrough').hide();
  let url = window.location.href;
  if (url.indexOf('?') > -1) {
    url += '&disable_banner=1';
  } else {
    url += '?disable_banner=1';
  }
  window.location.href = url;
});

$(document).on('shown.bs.modal', '#dw-modal', (e) => {
  const video = document.getElementById('dw_videoplayer');
  if (video) {
    video.play();
  }
});

$(document).on('hidden.bs.modal', '#dw-modal', (e) => {
  const video = document.getElementById('dw_videoplayer');
  if (video) {
    video.pause();
  }
});
